// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terminate-button {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2000;
    background: #b30000;
    color: white;
    padding: 8px 14px;
    border-radius: 6px;
    border: none;
    font-weight: bold;
    cursor: pointer;
}

.terminate-button:hover {
    background: #cc0000;
}

.notebook-wrapper {
    position: relative;
    margin-top: 20px; /* pushes notebook below header */
}

.notebook-iframe {
    width: 100%;
    height: calc(100vh - 120px);
    border: none;
}

.terminate-button {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
    background: #b30000;
    color: white;
    padding: 8px 14px;
    border-radius: 6px;
    border: none;
    font-weight: bold;
    cursor: pointer;
}


.notebook-iframe {
    width: 100%;
    height: calc(100vh - 120px);
    border: none;
    position: relative;
    z-index: 1;
}

.notebook-wrapper {
    position: relative;
    z-index: 1;
}

.terminate-button {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 9999; /* <-- REQUIRED */
    background: #b30000;
    color: white;
    padding: 8px 14px;
    border-radius: 6px;
    border: none;
    font-weight: bold;
    cursor: pointer;
}

.confirm-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 5000;
}

.confirm-box {
  background: #1e1e1e;
  padding: 25px 30px;
  border-radius: 10px;
  width: 320px;
  text-align: center;
  color: white;
  border: 1px solid #444;
}

.confirm-actions {
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
}

.confirm-stop {
  background: #b30000;
  color: white;
  padding: 8px 14px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}

.confirm-cancel {
  background: #555;
  color: white;
  padding: 8px 14px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/css/NotebookPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB,EAAE,iCAAiC;AACvD;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,2BAA2B;IAC3B,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa,EAAE,iBAAiB;IAChC,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB","sourcesContent":[".terminate-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    z-index: 2000;\n    background: #b30000;\n    color: white;\n    padding: 8px 14px;\n    border-radius: 6px;\n    border: none;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.terminate-button:hover {\n    background: #cc0000;\n}\n\n.notebook-wrapper {\n    position: relative;\n    margin-top: 20px; /* pushes notebook below header */\n}\n\n.notebook-iframe {\n    width: 100%;\n    height: calc(100vh - 120px);\n    border: none;\n}\n\n.terminate-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    z-index: 10;\n    background: #b30000;\n    color: white;\n    padding: 8px 14px;\n    border-radius: 6px;\n    border: none;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n\n.notebook-iframe {\n    width: 100%;\n    height: calc(100vh - 120px);\n    border: none;\n    position: relative;\n    z-index: 1;\n}\n\n.notebook-wrapper {\n    position: relative;\n    z-index: 1;\n}\n\n.terminate-button {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    z-index: 9999; /* <-- REQUIRED */\n    background: #b30000;\n    color: white;\n    padding: 8px 14px;\n    border-radius: 6px;\n    border: none;\n    font-weight: bold;\n    cursor: pointer;\n}\n\n.confirm-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0,0,0,0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 5000;\n}\n\n.confirm-box {\n  background: #1e1e1e;\n  padding: 25px 30px;\n  border-radius: 10px;\n  width: 320px;\n  text-align: center;\n  color: white;\n  border: 1px solid #444;\n}\n\n.confirm-actions {\n  margin-top: 20px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.confirm-stop {\n  background: #b30000;\n  color: white;\n  padding: 8px 14px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n}\n\n.confirm-cancel {\n  background: #555;\n  color: white;\n  padding: 8px 14px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
